var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69841 20.1414C2.61829 20.1437 1.62045 19.5647 1.08655 18.6258C0.560348 17.6926 0.591902 16.5452 1.1686 15.6424L6.54731 7.19601C7.10777 6.27183 8.12212 5.72068 9.20247 5.75333C10.282 5.7792 11.264 6.38448 11.7722 7.33731C12.2736 8.28542 12.2109 9.42612 11.6104 10.3161L6.23507 18.7625C5.68106 19.6258 4.72417 20.1459 3.69841 20.1414Z",
    fill: "#F62B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9244 20.141C11.8396 20.141 10.8413 19.561 10.3171 18.6288C9.79208 17.6982 9.82364 16.5537 10.3992 15.6534L15.7676 7.2264C16.32 6.28896 17.3374 5.72487 18.4251 5.75295C19.519 5.77689 20.5105 6.38883 21.0119 7.34605C21.5098 8.30328 21.4369 9.45082 20.8181 10.3385L15.4508 18.7655C14.8986 19.6251 13.9461 20.1437 12.9244 20.141Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9439 20.213C23.4733 20.213 24.713 18.9993 24.713 17.502C24.713 16.0048 23.4733 14.791 21.9439 14.791C20.4146 14.791 19.1748 16.0048 19.1748 17.502C19.1748 18.9993 20.4146 20.213 21.9439 20.213Z",
    fill: "#00CA72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonday);
export default __webpack_public_path__ + "static/media/Monday.8ebf8f22d7c7822a6530cf87477feedc.svg";
export { ForwardRef as ReactComponent };